import moment from 'moment'

// 订单诊断列表
export const orderDiagnosisList = [
  {
    key: 'recommendTime',
    label: '开方时间',
    formatter: time => {
      if (!time) return '无'
      return moment(time).format('YYYY-MM-DD HH:mm')
    }
  },
  {
    key: 'diagnosisName',
    label: '诊断'
  },
  {
    key: 'medicationName',
    label: '处方药品'
  },
  {
    key: 'followupPlanName',
    label: '单病种管理'
  }
]
